
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-fire-line',
      title: '自家焙煎',
      description: '毎朝新鮮な豆を店内で焙煎し、最高の香りと味をお届けします。30年の経験を持つ焙煎士が一粒一粒丁寧に焙煎いたします。',
      image: 'https://public.readdy.ai/ai/img_res/f0126a7d5026cafe4ac7c85a3b7d110d.jpg'
    },
    {
      icon: 'ri-home-line',
      title: '町家の雰囲気',
      description: '築100年の伝統的な町家を改装した店内では、木の温もりと落ち着いた照明が心地よい空間を演出しています。',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20machiya%20interior%20with%20wooden%20beams%2C%20warm%20lighting%2C%20tatami%20elements%2C%20traditional%20architecture%2C%20peaceful%20atmosphere%2C%20wooden%20furniture%2C%20cozy%20seating%20area&width=400&height=300&seq=machiya-atmosphere&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: '季節の味覚',
      description: '四季折々の新鮮な地元食材を使った軽食や和菓子をご用意。季節の移ろいと共に変わる味わいをお楽しみください。',
      image: 'https://readdy.ai/api/search-image?query=Seasonal%20Japanese%20ingredients%20and%20traditional%20sweets%20arranged%20beautifully%2C%20fresh%20local%20produce%2C%20seasonal%20wagashi%2C%20artistic%20food%20presentation%2C%20natural%20wooden%20background&width=400&height=300&seq=seasonal-ingredients&orientation=landscape'
    },
    {
      icon: 'ri-heart-line',
      title: 'おもてなしの心',
      description: 'お客様一人一人に合わせたサービスで、居心地の良い時間をお過ごしいただけるよう、心を込めてお迎えいたします。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20hospitality%20service%20in%20traditional%20coffee%20shop%2C%20staff%20member%20serving%20coffee%20with%20care%2C%20warm%20customer%20interaction%2C%20traditional%20Japanese%20service%20culture%2C%20welcoming%20atmosphere&width=400&height=300&seq=hospitality-service&orientation=landscape'
    },
    {
      icon: 'ri-music-line',
      title: '静寂の空間',
      description: '都市の喧騒から離れた静かな環境で、読書や仕事、瞑想など、思い思いの時間をゆっくりとお過ごしいただけます。',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20quiet%20corner%20in%20traditional%20Japanese%20coffee%20shop%2C%20reading%20nook%20with%20soft%20lighting%2C%20books%2C%20comfortable%20seating%2C%20serene%20atmosphere%2C%20wooden%20interior&width=400&height=300&seq=quiet-space&orientation=landscape'
    },
    {
      icon: 'ri-time-line',
      title: '伝統の継承',
      description: '30年間変わらない製法とレシピを大切にしながら、新しい挑戦も続けています。伝統と革新の調和をお楽しみください。',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20coffee%20brewing%20methods%20being%20passed%20down%2C%20vintage%20coffee%20equipment%2C%20master%20craftsman%20teaching%20techniques%2C%20traditional%20Japanese%20craftsmanship%2C%20heritage%20preservation&width=400&height=300&seq=tradition-heritage&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-br from-stone-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            町家珈琲の特徴
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
            30年の歴史と伝統を大切にしながら、お客様に最高のひとときをお届けするための、<br />
            私たちのこだわりをご紹介いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                      <i className={`${feature.icon} text-xl text-amber-700`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                      {feature.title}
                    </h3>
                  </div>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA エリア */}
        <div className="mt-20 text-center">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden max-w-4xl mx-auto">
            <div className="relative h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20Japanese%20coffee%20shop%20interior%20with%20customers%20enjoying%20peaceful%20moment%2C%20warm%20wooden%20atmosphere%2C%20soft%20lighting%20through%20shoji%20screens%2C%20people%20reading%20and%20relaxing%2C%20cozy%20seating%20arrangement&width=1200&height=400&seq=peaceful-moment&orientation=landscape"
                alt="心安らぐ町家珈琲の空間"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
            
            <div className="p-8">
              <h3 className="text-3xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                心安らぐ <em className="text-gray-600 font-light">木の温もり</em> をお楽しみください
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed max-w-2xl mx-auto">
                伝統的な町家の雰囲気の中で、自家焙煎の香り高いコーヒーと共に、<br />
                ゆったりとした特別なひとときをお過ごしください
              </p>
              <button className="bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-amber-900 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                ご来店予約
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
